import {
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from "@angular/common/http";

import { environment } from "../../../environments/environment";

export const httpClientInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const requestUrl = `${environment.apiUrl}/${req.url}`;
  const clonedReq = req.clone({
    url: requestUrl,
  });
  return next(clonedReq);
};
